import React from 'react';
import PreLoginPage from '../../../views/core/PreLoginPage';
import SpotlightBanner from './SpotlightBanner';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';
import $ from 'jquery';

// 'Fancy' theme - boilerplate styles for all components, as seen on our demo:
import 'react-accessible-accordion/dist/fancy-example.css';
// ES6 class-style
class FAQ extends PreLoginPage {
    constructor(props) {
        super(props);

        this.product = this.product.bind(this);
        this.regandlogin = this.regandlogin.bind(this);
        this.pricing = this.pricing.bind(this);
        //this.handleChange=this.handleChange.bind(this);
    }
    componentDidMount() {
        this.setTitle("FAQ_title");
        this.setMeta("FAQ_meta");
        this.setHeading("FAQ_heading");
    }
    handleChange(id) {

        //console.log("Accordian changed ",id);
        if ($('#matericon' + id).hasClass("minus")) {
            $('#matericon' + id).removeClass("minus")
            $('#matericon' + id).addClass("plus")
            $('#matericon' + id).html('<i class="material-icons">add</i>');
        } else {
            $('#matericon' + id).removeClass("plus")
            $('#matericon' + id).addClass("minus")
            $('#matericon' + id).html('<i class="material-icons">remove</i>');
        }
    }

    product() {
        return (
            <AccordionItem expanded={false}>
                <AccordionItemTitle>
                    <div>
                        <h3>1. Product <span id="matericon1"><i class="material-icons">add</i></span></h3>
                    </div>
                </AccordionItemTitle>
                <AccordionItemBody>
                    <div className="faqcnt">
                        <h3 className="blustr">1.1) How does HeyMath! Work?</h3>
                        <div>
                            HeyMath! assures continuous progress from wherever your child is in his or her Math learning journey. We cover everything from counting to calculus.
                            <br />
                            <div className="txtindent">
                                Our program helps
                            </div>
                        </div>

                        <table>
                            <tr>
                                <td>1. </td>
                                <td>Develop an interest in Maths</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>Build a positive attitude toward learning</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>Become a self-directed independent learner</td>
                            </tr>
                        </table>


                    </div>

                    <div className="faqcnt">
                        <h3 className="blustr">1.2) How can HeyMath! help me as a parent?</h3>
                        <div>
                            Through HeyMath!, you are armed with a granular report card and in-depth insights of your child’s Math performance that help you truly guide your child.
                        </div>
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">1.3) How is HeyMath! different from tuitions?</h3>

                        <table>
                            <tr>
                                <td>1. </td>
                                <td>You will be able to move at your own pace every day at your home</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>You can align your practice and revision schedule to the school’s academic calendar</td>
                            </tr>
                        </table>
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">1.4) How many hours should my child spend every day on HeyMath!?</h3>
                        We believe Math is not a spectator sport. We recommended you spend 20 minutes a day going through our lessons and practice.
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">1.5) I am unaware where my child stands when it comes to Math. Can HeyMath! help?</h3>
                        Absolutely. Encourage your child to take free diagnostic tests available for grades 5 to 10. You will get a detailed report card on your child’s strengths and weaknesses.
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">1.6) What are Self-Paced Lessons?</h3>
                        In the Self-Paced Lessons modules for grades 1 to 4, you will get video lessons aligned to CBSE curriculum. You will also get access to many solved examples, interactive activities and quizzes to check your understanding. Our lessons build vocabulary, comprehension skills and inculcate Mathematical thinking. Also, we have infused proven pedagogies from Singapore’s world-class education system and adapted them for CBSE, ICSE and local boards.
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">1.7) Why and what is Personalised Learning?</h3>
                        <div className="txtindent">
                            Personalised Learning is a real alternative to tuitions<br />
                        </div>


                        <table>
                            <tr>
                                <td>1. </td>
                                <td>Teachers do not have the luxury of time to ‘bridge learning gaps’ from previous years nor do they find it feasible to provide individual attention to each student</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>Over time, some students start developing anxieties due to poor performance in tests.</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>You end up resorting to tuitions; which also doesn’t necessarily resolve the problem</td>
                            </tr>
                        </table>
                        <br />
                        Personalised Learning is customised for each student, diagnoses deﬁciencies at a granular level and bridges learning gaps through recommended lessons and targeted practice. With regular usage of PLP, students are sure to do better in school tests
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">1.8) I want to know more about HeyMath! Can I speak with someone from HeyMath?</h3>
                        You can call/Whatsapp us at <span className="whatsapp">+91 9884400755</span> or email us at <a href="support@heymath.com">support@heymath.com</a>
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">1.9) I am the Principal/Founder/Trustee etc of a school and I want HeyMath! Implementation in my school. Who should I contact?</h3>
                        Please write a mail to <a href="support@heymath.com">support@heymath.com</a> and we will contact you for the implementation.
                    </div>


                    <div className="faqcnt">
                        <h3 className="blustr">1.10) What are the supported devices for HeyMath?</h3>
                        <div className="txtindent">
                            For users enrolled through school (including teachers/tutors who have independently registered), we recommend accessing HeyMath! on desktop/laptop <br /><br />
                            For users who have independently registered,
                        </div>
                        <table>
                            <tr>
                                <td>1. </td>
                                <td>Classes 1-4: we recommend using on desktop/laptop</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>Classes 5-10: available for use on all devices</td>
                            </tr>
                        </table>
                    </div>

                </AccordionItemBody>
            </AccordionItem>
        )
    }

    regandlogin() {
        let telPhoneNo = window.telPhoneNo[this.getGeo()] || window.telPhoneNo['OTHERS'] || '+91 44 3500 2073';
        return (
            <AccordionItem>
                <AccordionItemTitle>
                    <div>
                        <h3>2. Registration & Login <span id="matericon2"><i class="material-icons">add</i></span></h3>
                    </div>
                </AccordionItemTitle>
                <AccordionItemBody>
                    <div className="faqcnt">
                        <h3 className="blustr">2.1) How do I Sign-up?</h3>

                        <table>
                            <tr>
                                <td>1. </td>
                                <td>Click on Sign In button at the top right corner.</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>Click on 'Users who have independently registered'</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>Choose either 'Sign In with Google' or 'Create an Account'</td>
                            </tr>
                            <tr>
                                <td>4. </td>
                                <td>Only for users who choose to 'Create an Account':
                                    <tr>
                                        <td>a.
                                        </td>
                                        <td>Fill in the details and verify your email ID by clicking on “Verify Passcode”
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>b.
                                        </td>
                                        <td>Enter the 6-digit Passcode that has been sent to your Email ID
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>c.
                                        </td>
                                        <td>Click Sign In
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                            <tr>
                                <td>5. </td>
                                <td>Choose the grade in the ‘Classes page’ or directly choose your grade from the drop-down on the Classes tab
                                </td>
                            </tr>
                            <tr>
                                <td>6. </td>
                                <td>Choose ‘Subscribe’ or ‘Start a Free trial’</td>
                            </tr>
                        </table>
                    </div>

                    <div className="faqcnt">
                        <h3 className="blustr">2.2) How do I start a free trial HeyMath after signing up?</h3>
                        <table>
                            <tr>
                                <td>1. </td>
                                <td>Login with your User ID and password chosen while signing up. In case you signed-up with your Google account, your email ID is the User ID</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>Choose the grade in the ‘Classes page’ or directly choose your grade from the drop-down on the Classes tab</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>In the respective grade page, choose 'Free Trial'</td>
                            </tr>
                            <tr>
                                <td>4. </td>
                                <td>Click on 'My HeyMath' to access HeyMath! content after starting a free trial</td>
                            </tr>
                        </table>
                    </div>

                    <div className="faqcnt">
                        <h3 className="blustr">2.3) I have a HeyMath! user ID and password from my school. How do I sign in?</h3>

                        <table>
                            <tr>
                                <td>1. </td>
                                <td>Click on the Sign-In button on the top right corner of the screen</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>Click on “Users enrolled through school” (the green card)</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>Enter the school provided user ID and password</td>
                            </tr>
                        </table>
                    </div>

                    <div className="faqcnt">
                        <h3 className="blustr">2.4) What can I do if I have forgotten my password?</h3>

                        <table>
                            <tr>
                                <td>1. </td>
                                <td>Click on 'Sign-In' at the top right corner</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>Choose the right option to proceed: 'Users enrolled through HeyMath!' or 'Users who have independently registered'</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>Click on 'Forgot Password' above 'Sign-In' button</td>
                            </tr>
                            <tr>
                                <td>4. </td>
                                <td>For users who got received their ID from school
                                    <tr>
                                        <td>a.
                                        </td>
                                        <td>Enter your registered email ID, the User ID given by the school and click on 'Send’
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>b.
                                        </td>
                                        <td>We will share a new password on email
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                        </table>

                        <div className="txtindent">Note: If your email ID is not registered, please write an email to <a href="support@heymath.com">support@heymath.com</a></div>


                        <table>
                            <tr>
                                <td>5. </td>
                                <td>For users who subscribed to HeyMath! on their own
                                    <tr>
                                        <td>a.
                                        </td>
                                        <td>Enter your email ID/mobile number and click on 'Send OTP'
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>b.
                                        </td>
                                        <td>Enter the OTP in 'Enter OTP' field and click on 'Verify'
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>c.
                                        </td>
                                        <td>Now reset your password and start accessing HeyMath!
                                        </td>
                                    </tr>
                                </td>
                            </tr>
                        </table>
                    </div>

                    <div className="faqcnt">
                        <h3 className="blustr">2.5) How do I subscribe to HeyMath! for two children?</h3>
                        We advise subscribing to a distinct account for each child to ensure simultaneous access to HeyMath! To do this, you can subscribe using your mobile number for one account and email ID for the other account. Alternatively, you could use 2 mobile numbers and/or 2 email ids.
                    </div>

                    <div className="faqcnt">
                        <h3 className="blustr">2.6) How do I reset my password?</h3>
                        <div className="txtindent">
                            For users who independently registered:</div>
                        <table>
                            <tr>
                                <td>1. </td>
                                <td>After logging-in, click on ‘My Account’ icon at the top right corner</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>In the drop-down, choose ‘My Profile’</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>Fill-in your old password and the new password you want</td>
                            </tr>
                            <tr>
                                <td>4. </td>
                                <td>Click on ‘Save’</td>
                            </tr>
                        </table>
                        <div className="txtindent">
                            For users who enrolled through school
                        </div>
                        <table>
                            <tr>
                                <td>1. </td>
                                <td>After logging-in, click on ‘My Account’ icon at the top right corner</td>
                            </tr>
                            <tr>
                                <td>2. </td>
                                <td>In the drop-down, choose ‘Profile’</td>
                            </tr>
                            <tr>
                                <td>3. </td>
                                <td>Fill in the new password that you want</td>
                            </tr>
                            <tr>
                                <td>4. </td>
                                <td>Click on ‘Save’</td>
                            </tr>
                        </table>
                    </div>

                    <div className="faqcnt">
                        <h3 className="blustr">2.7) What is the helpline number for HeyMath?</h3>
                        The helpline is <span className="whatsapp">{telPhoneNo}</span>
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">2.8) What is the helpline email ID for HeyMath?</h3>
                        The helpline email ID is <a href="support@heymath.com">support@heymath.com</a>
                    </div>
                </AccordionItemBody>
            </AccordionItem>
        )
    }


    pricing() {
        return (
            <AccordionItem>
                <AccordionItemTitle>
                    <div>
                        <h3>3. Pricing <span id="matericon3"><i class="material-icons">add</i></span></h3>
                    </div>
                </AccordionItemTitle>
                <AccordionItemBody>
                    <div className="faqcnt">
                        <h3 className="blustr">3.1) Can I use HeyMath! for free?</h3>
                        <div>You can start a free trial on HeyMath!. Students in grades 1 to 10 can take FREE mini diagnostic tests across all curriculum topics and view a detailed report card of their performance. To receive personalised study plans, you will need to upgrade to a paid subscription of Rs. 4999 per year.</div>

                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">3.2) My child is going to the next class in a few months. Can I purchase a monthly subscription instead of an annual one?</h3>
                        <div>We currently do not have a monthly subscription. You can email us once your child has gone to the next class. We will, then, shift your child’s subscription to the next class.
                        </div>
                        <div>Note: Only for students in classes 1 to 3 and in classes 5 to 9
                        </div>
                    </div>
                    <div className="faqcnt">
                        <h3 className="blustr">3.3) What are the payment options?</h3>
                        <div>
                            There are multiple payment options. You can pay using Credit/debit cards/netbanking/wallets/paytm etc.
                        </div>
                    </div>
                </AccordionItemBody>
            </AccordionItem>
        )
    }


    render() {
        return (
            <div id="FAQ">
                <SpotlightBanner title={this.rb("FAQ.title")} />
                <div>
                    <div className="container">
                        <div className="faqaccord">
                            <Accordion onChange={this.handleChange.bind(this, 1)}>

                                {this.product()}
                            </Accordion>


                            <Accordion onChange={this.handleChange.bind(this, 2)}>
                                {this.regandlogin()}
                            </Accordion>


                            <Accordion onChange={this.handleChange.bind(this, 3)}>
                                {this.pricing()}
                            </Accordion>
                        </div>
                    </div>
                </div>
                {/* <div className="text-center">
      (Got questions for us? - clickable link opening ‘Contact Us’ form)
      </div> */}
            </div>
        )
    }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/prelogin/src/components/FAQ.js